var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKycIncomplete = function SvgKycIncomplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycIncomplete_svg__a)",
    d: "M62.422.984H7.578A7.31 7.31 0 0 0 .266 8.297v91.406a7.313 7.313 0 0 0 7.312 7.313h54.844a7.313 7.313 0 0 0 7.312-7.313V8.297A7.31 7.31 0 0 0 62.422.984"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycIncomplete_svg__b)",
    d: "M69.734 8.297V92.39H.266V8.297A7.31 7.31 0 0 1 7.578.984h54.844a7.31 7.31 0 0 1 7.312 7.313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9E4F7",
    d: "M40.484 101.531H29.516a1.827 1.827 0 1 1 0-3.656h10.968a1.828 1.828 0 0 1 0 3.656M22.203.984h25.594v3.657a3.656 3.656 0 0 1-3.656 3.656H25.859a3.656 3.656 0 0 1-3.656-3.656z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.333 72.281a1.83 1.83 0 0 0-2.497-.67l-2.008 1.16v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.008-1.16a1.827 1.827 0 0 0-2.68 2.058 1.83 1.83 0 0 0 .852 1.11l2.007 1.159-2.007 1.158a1.829 1.829 0 0 0 1.828 3.167l2.008-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.827 1.827 0 0 0 2.68-2.058 1.83 1.83 0 0 0-.852-1.11l-2.007-1.159 2.007-1.158a1.83 1.83 0 0 0 .67-2.498M23.052 72.281a1.827 1.827 0 0 0-2.497-.67l-2.008 1.16v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.008-1.16a1.828 1.828 0 1 0-1.828 3.168l2.007 1.159-2.007 1.158a1.828 1.828 0 0 0 1.828 3.167l2.008-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.828 1.828 0 1 0 1.828-3.168l-2.007-1.159 2.007-1.158a1.83 1.83 0 0 0 .67-2.498M58.945 77.096l-2.007-1.159 2.007-1.158a1.829 1.829 0 1 0-1.828-3.167l-2.008 1.159v-2.318a1.828 1.828 0 0 0-3.656 0v2.318l-2.007-1.16a1.828 1.828 0 1 0-1.828 3.168l2.006 1.159-2.006 1.158a1.828 1.828 0 0 0 1.828 3.167l2.007-1.159v2.318a1.828 1.828 0 0 0 3.656 0v-2.318l2.008 1.16a1.828 1.828 0 1 0 1.828-3.168"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycIncomplete_svg__c)",
    d: "M35 19.266a27.97 27.97 0 0 1-18.281 7.312v10.969C16.719 54.783 35 61.313 35 61.313s18.281-6.53 18.281-23.766V26.578A27.97 27.97 0 0 1 35 19.266"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.507 32.653a.94.94 0 1 0-1.33 1.329l4.98 4.98-4.98 4.98a.94.94 0 1 0 1.33 1.328l4.98-4.98 4.98 4.98a.94.94 0 0 0 1.329-1.329l-4.98-4.98 4.98-4.98a.94.94 0 0 0-1.33-1.328l-4.98 4.98z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycIncomplete_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(121.418 30.012 22.02)scale(112.527 93.1005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycIncomplete_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-58.65862 82.7822 -72.62922 -51.46433 64.45 6.935)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kycIncomplete_svg__c",
    x1: 35,
    x2: 35,
    y1: 16.019,
    y2: 76.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgKycIncomplete;